export const CHANGE_LOCALE = "CHANGE_LOCALE";
export const SET_DARK_MODE = "SET_DARK_MODE";
export const SET_ASIDE_SHOW = "SET_ASIDE_SHOW";
export const SET_FEDERAL_POLL_MAP = "SET_FEDERAL_POLL_MAP";
export const SET_PROVINCIAL_POLL_MAP = "SET_PROVINCIAL_POLL_MAP";
export const SET_PROVINCIAL_LEADERSHIP_POLL_MAP = "SET_PROVINCIAL_LEADERSHIP_POLL_MAP";
export const SET_SIDEBAR_SHOW = "SET_SIDEBAR_SHOW";
export const SET_SEARCH_RESULTS = "SET_SEARCH_RESULTS";
export const SET_SHOW_INFOBOX = "SET_SHOW_INFOBOX";
export const SET_VIEW_ADJUST = "SET_VIEW_ADJUST";

export const SET_MAP_SELECTED = "SET_MAP_SELECTED";
export const SET_MAP_COUNT = "SET_MAP_COUNT";

export const SET_POLL_MAP = "SET_POLL_MAP";
export const SET_POLL_MAP_OVERLAY = "SET_POLL_MAP_OVERLAY";
export const SET_POLL_MAP_PARTIES = "SET_POLL_MAP_PARTIES";
export const SET_POLL_MAP_YEAR = "SET_POLL_MAP_YEAR";
export const SET_POLL_MAP_LOCAL_DIVISION = "SET_POLL_MAP_LOCAL_DIVISION";

export const SET_MAPMAKER_RIDING_PARTY = "SET_MAPMAKER_RIDING_PARTY";
export const SET_MAPMAKER_BOUNDS = "SET_MAPMAKER_BOUNDS";
export const SET_SHOW_MAPMAKER_INFOBOX = "SET_SHOW_MAPMAKER_INFOBOX";
export const RESET_MAPMAKER_MAP = "RESET_MAPMAKER_MAP";

export const RESET_MAPMAKER_MAP_F = "RESET_MAPMAKER_MAP_F";
export const SET_MAPMAKER_RIDING_PARTY_F = "SET_MAPMAKER_RIDING_PARTY_F";

export const LOGIN_USER = "LOGIN_USER";
export const LOGIN_USER_SUCCESS = "LOGIN_USER_SUCCESS";
export const LOGIN_USER_ERROR = "LOGIN_USER_ERROR";
export const REGISTER_USER = "REGISTER_USER";
export const REGISTER_USER_SUCCESS = "REGISTER_USER_SUCCESS";
export const REGISTER_USER_ERROR = "REGISTER_USER_ERROR";
export const LOGOUT_USER = "LOGOUT_USER";
export const FORGOT_PASSWORD = "FORGOT_PASSWORD";
export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_ERROR = "FORGOT_PASSWORD_ERROR";
export const RESET_PASSWORD = "RESET_PASSWORD";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_ERROR = "RESET_PASSWORD_ERROR";